// extracted by mini-css-extract-plugin
export default {"workOrders":"WorkOrders_workOrders__wF+Ep","pageHeader":"WorkOrders_pageHeader__wvuW4"};